module.exports = __webpack_public_path__ + "img/spinner.a21746f5.gif";